import { FCElement } from '@fc/component';
import { debounce } from '@fc/utilities';

class ProductTitle extends FCElement {
  #ro = null;
  #ac = null;
  #onResize = null;

  connectedCallback() {
    super.connectedCallback();
    this.#observe();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#teardown();
  }

  #observe() {
    const update = () => requestAnimationFrame(() => this.#clamp());

    if (typeof ResizeObserver !== 'undefined') {
      this.#ro = new ResizeObserver(update);
      this.#ro.observe(this);
    } else {
      this.#ac = new AbortController();
      this.#onResize = debounce(() => this.#clamp(), 150);
      window.addEventListener('resize', this.#onResize, {
        passive: true,
        signal: this.#ac.signal,
      });
    }

    update();
  }

  #clamp() {
    const el = this.refs?.text ?? this.querySelector('.title-text') ?? this;
    if (!(el instanceof HTMLElement) || !el.textContent?.trim()) return;
    if (this.clientHeight <= 0) return;

    const { fontSize, lineHeight: lh, paddingTop, paddingBottom } = getComputedStyle(this);
    const size = parseFloat(fontSize) || 16;
    const leading = lh === 'normal' ? size * 1.2 : parseFloat(lh) || size * 1.2;
    const inner = this.clientHeight - (parseFloat(paddingTop) || 0) - (parseFloat(paddingBottom) || 0);
    if (inner <= 0) return;

    Object.assign(el.style, {
      display: '-webkit-box',
      webkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      webkitLineClamp: String(Math.max(1, Math.floor(inner / leading))),
    });
  }

  #teardown() {
    this.#ro?.disconnect();
    this.#ro = null;
    this.#ac?.abort();
    this.#ac = null;
    this.#onResize = null;
  }
}

if (!customElements.get('product-heading')) {
  customElements.define('product-heading', ProductTitle);
}

export default ProductTitle;
